import {
  Button,
  Divider,
  Typography,
  Box,
  Popover,
  Autocomplete,
  TextField,
  IconButton,
  Grid,
} from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
// import { Message } from '../../utils/messages';
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
import { DialogContext, AlertContext } from "../../contexts";
import { AlertProps } from "../../utils";
// import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { ColorTextBox, FileUpload, IsRequired } from "../../components";
import {
  scenarioStateMappingUpdate,
  updateRepoMappedInScenario,
} from "../../utils/apiCall";
import { BootstrapTooltip } from "./statesAndAction";

const callTypes = ["Nifi", "Api", "Service Call"];

const useStyles = makeStyles((theme) => ({
  Header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 16px",
    background: theme.palette.background.table,
  },
  Header2: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 16px",
    height: "52px",
    background: theme.palette.background.table,
  },
  wrapperdiv: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: "8px 16px 24px 16px",
  },
  actionList: {
    padding: "8px 16px",
    height: "calc(100% - 108px)",
    overflowY: "auto",
    background: theme.palette.background.common,
  },
  actionListItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  wrapperdiv2: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px 16px",
    background: theme.palette.background.common,
    borderTop: " 1px solid #e0e0e0",
  },
  wrapperdiv3: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: "8px 16px 0 16px",
    // borderTop: " 1px solid #e0e0e0",
    background: theme.palette.background.table,
  },
  content: {
    // padding: "16px",
    height: "52px",
    // overflow: "auto",
    background: theme.palette.background.common,
  },
  Button: {
    background: theme.palette.button.background,
    color: theme.palette.button.text,
    "&:hover": {
      backgroundColor: theme.palette.button.hover,
    },
  },
  Popover: {
    background: theme.palette.background.table,
    width: "360px",
    padding: theme.spacing(2),
  },
  icon: {
    width: "30px",
    height: "30px",
    // boxShadow: "0 0 2px rgb(184 184 184)",
    borderRadius: "50%",
    padding: "4px",
    color: theme.palette.text.primary,
  },
}));

// const styles = (theme) => ({
//   Popover: {
//     background: theme.palette.background.table,
//   },
// });

export const DrawerAddAction = (props) => {
  const classes = useStyles();
  const dialogContext = React.useContext(DialogContext);
  const alertProps = React.useContext(AlertContext);
  const alertMessage = React.useContext(AlertContext);
  // const projectinfo = React.useContext(ProjectInfoContext);
  const [state, setState] = React.useState({
    action: "",
    // idmrole: [],
    apiendpoint: "",
    chooseform: "",
    choosetype: "",
    bgcolor: "",
    icon: "",
    textcolor: "",
  });
  const [isupdate, setUpdate] = React.useState(false);

  const [action, setAction] = React.useState([]);
  const [focused, setFocused] = React.useState(false);
  const onFocus = () => setFocused(true);

  const onBlur = () => setFocused(false);

  React.useEffect(() => {
    getStatesActionData();
    // eslint-disable-next-line
  }, []);

  const getStatesActionData = async () => {
    try {
      let params = {
        db_name: `${localStorage.getItem("ProjectDbname")}`,
        entity: "queuestatesaction",
        filter: `queuestatesaction.queueid=='${props?.data?.queueid}'&& queuestatesaction.statesid=='${props?.data?._id}'  && queuestatesaction.activestatus==true`,
        return_fields: "queuestatesaction",
      };
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_NODERED_BASE_URL_READ}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      };
      await axios(config)
        .then((res) => {
          setAction(res.data.result);
          console.log(res.data.result);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const open = Boolean(state.anchorEl);
  const id = open ? "simple-popover" : undefined;

  const OnAddAnotherClicked = (e) => {
    setState({ ...state, anchorEl: e.currentTarget, isEdit: false });
  };

  const onHandleChange = (key, value) => {
    // setState({ ...state, [e.target.name]: e.target.value });
    if (key === "action") {
      setState({ ...state, [key]: value.toUpperCase() });
      setUpdate(true);
    } else {
      setState({ ...state, [key]: value });
    }
  };
  const onPopoverClose = () => {
    setState({
      ...state,
      isEdit: false,
      anchorEl: null,
      // idmrole: [],
      action: "",
      apiendpoint: "",
      chooseform: "",
      choosetype: "",
      bgcolor: "",
      icon: "",
      textcolor: "",
    });
  };
  const onSettingClicked = (e, item) => {
    setState({
      ...state,
      anchorEl: e.currentTarget,
      isEdit: true,
      _key: item?._key,
      actionid: item?.actionid,
      action: item?.action,
      bgcolor: item?.bgcolor,
      icon: item?.icon,
      textcolor: item?.textcolor,
      // idmrole: item?.idmrole,
      apiendpoint: item?.apiendpoint,
      chooseform: item?.chooseform,
      choosetype: item?.choosetype,
      _id: item?._id,
      statesid: props?.data?._id,
      existingAction: item?.action,
    });
  };

  const onUpdatepopover = async () => {
    let isaction = state?.action.trim().length === 0 ? true : false;
    let isChoosetype = state?.choosetype.trim().length === 0 ? true : false;
    let isChooseform = state?.chooseform.trim().length === 0 ? true : false;
    let isApiendpoint = state?.apiendpoint.trim().length === 0 ? true : false;
    if (isChoosetype && isChooseform && isApiendpoint && isaction) {
      alertProps.setSnack({
        ...alertProps,
        open: true,
        severity: AlertProps.severity.error,
        msg: "Some field are empty",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.center,
      });
    } else {
      let checkAction =
        state?.action === state?.existingAction
          ? true
          : action.filter(
              (list) => list.action.toLowerCase() === state.action.toLowerCase()
            ) > 0
          ? false
          : true;
      if (!checkAction) {
        alertMessage?.setSnack({
          ...alertMessage,
          open: true,
          severity: AlertProps.severity.error,
          msg: "Action Name already exists",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.center,
        });
      } else {
        await updateAction(state);
        if (state?.action !== state?.existingAction) {
          await updateRepoMappedInScenario(state?._id, state?.action, "update");
        }
        await updateActionMappedWithScenarios(props?.data?.queueid, state);

        onPopoverClose();
      }
      // updateAction(state);
      // onPopoverClose();
    }
  };

  const updateActionbyState = (action, newState) => {
    // debugger;
    let updateaction = action?.map((l) =>
      l._id === newState?._id
        ? {
            ...l,
            action: newState?.action,
            bgcolor: newState?.bgcolor,
            icon: newState?.icon,
            textcolor: newState?.textcolor,
            apiendpoint: newState?.apiendpoint,
            chooseform: newState?.chooseform,
            choosetype: newState?.choosetype,
          }
        : l
    );
    return updateaction ?? [];
  };

  const getState = (state, newState) => {
    // console.log("state", state, newState,id);

    let list = state?.map((g) =>
      g?._id === newState?.statesid
        ? {
            ...g,
            action: updateActionbyState(g?.action, newState),
          }
        : g
    );
    return list;
  };

  const actionName = (actionlist, state, text) => {
    let actname =
      actionlist?.find((l) => l._id === state?._id).action === text
        ? state?.action
        : text;
    return actname;
  };

  const updateWorkflow = (wflow, newState) => {
    let wflw = wflow?.map((l) =>
      l?.data?.value?.status?._id === newState?.statesid
        ? {
            ...l,
            data: {
              ...l?.data,
              ...(l?.data?.text && {
                text:
                  l?.data?.actionState === "true"
                    ? actionName(
                        l?.data?.value?.status?.action,
                        newState,
                        l?.data?.text
                      )
                    : l?.data?.text,
              }),
              value: {
                status: {
                  ...l?.data?.value?.status,
                  action: updateActionbyState(
                    l?.data?.value?.status?.action,
                    newState
                  ),
                },
              },
            },
          }
        : l
    );
    return wflw;
  };

  const updateActionMappedWithScenarios = async (queueid, state) => {
    try {
      let params = {
        db_name: `${localStorage.getItem("ProjectDbname")}`,
        entity: "queuescenariostatemapping",
        filter: `queuescenariostatemapping.queueid=='${queueid}' && queuescenariostatemapping.activestatus==true`,
        return_fields: "queuescenariostatemapping",
      };
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_NODERED_BASE_URL_READ}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      };
      const res = await axios(config);

      let mappedScenario = res?.data?.result;

      if (mappedScenario?.length > 0) {
        let mappedNewWithState = mappedScenario?.map((l) => {
          let list = {
            ...l,
            states: getState(l.states, state),
            workflowdiagram: updateWorkflow(l.workflowdiagram, state),
          };
          return list;
        });

        let responeList = mappedNewWithState.map(
          async (l) => await scenarioStateMappingUpdate(l)
        );

        return responeList;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateAction = async (value) => {
    let datas = {
      queueid: props?.data?.queueid,
      statesid: props?.data?._id,
      actionid: value?.actionid,
      action: value?.action,
      bgcolor: value?.bgcolor,
      icon: value?.icon,
      textcolor: value?.textcolor,
      // idmrole: value?.idmrole,
      apiendpoint: value?.apiendpoint,
      chooseform: value?.chooseform,
      choosetype: value?.choosetype,
      // isEdit: false,
      version: "",
      active: true,
    };
    try {
      let params = [
        {
          db_name: `${localStorage.getItem("ProjectDbname")}`,
          entity: "queuestatesaction",
          filter: {
            _key: `${value._key}`,
          },
          is_metadata: true,
          metadataId: `${localStorage.getItem("metaId")}`,
          metadata_dbname: `${process.env.REACT_APP_MetadataDB_Name}`,
          doc: datas,
        },
      ];
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_NODERED_BASE_URL_UPSERT}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      };
      await axios(config).then((res) => {
        if (res.data.Code === 201) {
          getStatesActionData();
          props?.getStatesData();
          alertMessage?.setSnack({
            ...alertMessage,
            open: true,
            severity: AlertProps.severity.success,
            msg: "Action Updated Successfully",
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.center,
          });
          setUpdate(false);
        } else if (res.data.Code === 1111) {
          alertMessage?.setSnack({
            ...alertMessage,
            open: true,
            severity: AlertProps.severity.error,
            msg: `${res?.data?.error ?? "Something Went Wrong"}`,
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.center,
          });
        } else {
          alertMessage?.setSnack({
            ...alertMessage,
            open: true,
            severity: AlertProps.severity.error,
            msg: "Something Went Wrong",
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.center,
          });
        }

        // console.log(res);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const onDialogOpen = (_key, _id) => {
    dialogContext.setDialog({
      ...dialogContext,
      open: true,
      title: "Are you sure you want to delete this action?",
      body: "",
      positiveBtn: "Confirm",
      negativeBtn: "Cancel",
      onOk: () => onDeletedClicked(_key, _id),
    });
  };

  const onDeletedClicked = (_key) => {
    dialogContext.setDialog({
      ...dialogContext,
      open: false,
    });
    statesSoftDelete(_key);
  };
  const statesSoftDelete = async (_key) => {
    try {
      debugger;
      let params = {
        db_name: `${localStorage.getItem("ProjectDbname")}`,
        entity: "queuestatesaction",
        filter: `queuestatesaction._key=='${_key}'`,
        metadata_dbname: `${process.env.REACT_APP_MetadataDB_Name}`,
      };
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_NODERED_BASE_URL_SOFTDELETE}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      };
      await axios(config).then(async (res) => {
        let _id = res?.data?.Result[0]?.doc?._id;

        await updateRepoMappedInScenario(_id, "", "softDelete");
        await getStatesActionData();
        props?.getStatesData();
        alertMessage?.setSnack({
          ...alertMessage,
          open: true,
          severity: AlertProps.severity.success,
          msg: "Action Deleted Successfully",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.center,
        });
        // console.log(res);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const onPopSave = () => {
    let isaction = state?.action.trim().length === 0 ? false : true;
    // let isChoosetype = state?.choosetype.trim().length === 0 ? false : true;
    // let isChooseform = state?.chooseform.trim().length === 0 ? false : true;
    // let isApiendpoint = state?.apiendpoint.trim().length === 0 ? false : true;
    if (isaction) {
      let checkAction = action.filter(
        (list) => list.action.toLowerCase() === state.action.toLowerCase()
      );
      if (checkAction.length !== 0) {
        alertMessage?.setSnack({
          ...alertMessage,
          open: true,
          severity: AlertProps.severity.error,
          msg: "Action Name already exists",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.center,
        });
      } else {
        upsertAction(state);
      }
    } else {
      // console.log(state);
      alertProps.setSnack({
        ...alertProps,
        open: true,
        severity: AlertProps.severity.error,
        msg: "Required fields are empty",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.center,
      });
    }
  };
  const upsertAction = async (value) => {
    let datas = {
      queueid: props?.data?.queueid,
      statesid: props?.data?._id,
      actionid: "",
      action: value?.action,
      bgcolor: value?.bgcolor,
      icon: value?.icon,
      textcolor: value?.textcolor,
      // idmrole: value?.idmrole,
      apiendpoint: value?.apiendpoint,
      chooseform: value?.chooseform,
      choosetype: value?.choosetype,
      // isEdit: false,
      version: "",
      active: true,
    };

    try {
      let params = [
        {
          db_name: `${localStorage.getItem("ProjectDbname")}`,
          entity: "queuestatesaction",
          is_metadata: true,
          metadataId: `${localStorage.getItem("metaId")}`,
          metadata_dbname: `${process.env.REACT_APP_MetadataDB_Name}`,
          doc: datas,
        },
      ];
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_NODERED_BASE_URL_UPSERT}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      };
      await axios(config).then((res) => {
        if (res.data.Code === 201) {
          alertMessage?.setSnack({
            ...alertMessage,
            open: true,
            severity: AlertProps.severity.success,
            msg: "Action Added Successfully",
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.center,
          });
          getStatesActionData();
          onPopoverClose();
          // console.log(res);
          props?.getStatesData();
        } else if (res.data.Code === 1111) {
          alertMessage?.setSnack({
            ...alertMessage,
            open: true,
            severity: AlertProps.severity.error,
            msg: `${res?.data?.error ?? "Something Went Wrong"}`,
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.center,
          });
        } else {
          alertMessage?.setSnack({
            ...alertMessage,
            open: true,
            severity: AlertProps.severity.error,
            msg: "Something Went Wrong",
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.center,
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ height: "100vh" }}>
      <Box className={classes.Header2}>
        <Typography variant="body1">Add Action</Typography>
      </Box>
      <Divider />
      <div className={classes.actionList}>
        {action?.map((item, index) => (
          <div key={index}>
            <div className={classes.actionListItem}>
              <Typography variant="body2">{item.action}</Typography>
              <div>
                <IconButton
                  id={"Settings Icon"}
                  onClick={(e) => onSettingClicked(e, item)}
                >
                  <SettingsOutlinedIcon className={classes.icon} />
                </IconButton>
                <IconButton
                  id={"Delete Icon"}
                  className={classes.icon}
                  onClick={(e) => onDialogOpen(item?._key)}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </div>

            <Divider />
          </div>
        ))}
        <Button
          onClick={(e) => OnAddAnotherClicked(e)}
          variant="text"
          style={{ color: "#3495FF", marginTop: "8px" }}
        >
          {action?.length === 0 ? "+ Add Action" : "+Add Another Action"}
        </Button>
      </div>
      <div className={classes.content}>
        <Divider />
        <div className={classes.wrapperdiv2}>
          <Button onClick={() => props.onDrawerClosed()} variant="outlined">
            {"Cancel"}
          </Button>
          {/* <Button onClick={() => onSaveClicked()} variant='contained' sx={{ ml: "16px" }} >
                    {"Save"}
                </Button> */}
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={state?.anchorEl}
        onClose={onPopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Grid className={classes.Popover}>
          <Grid item xs={12}>
            <Typography variant="body2" gutterBottom>
              {"Action "}
              <IsRequired />
            </Typography>
            <BootstrapTooltip
              title="If you are trying to update the action name,Please check the scenarios state's action mapping, workflow and its rule configuration"
              open={state?.isEdit && focused}
            >
              <TextField
                id="outlined-name"
                // label="Enter State Name"
                name="action"
                value={state?.action}
                autoComplete="off"
                onChange={(e) => onHandleChange("action", e.target.value)}
                placeholder="Enter Action Name"
                fullWidth
                onFocus={onFocus}
                onBlur={onBlur}
                size="small"
                // margin="dense"
                // error={state?.errorStatesName}
                // helperText={state?.errorStatesName === true ? Message.requiredMessage : ""}
              />
            </BootstrapTooltip>
          </Grid>
          {/* <Grid item xs={12} sx={{ py: 1 }}>
            <Typography variant="body2" gutterBottom>
              {"Role"}
            </Typography>
            <Autocomplete
              id="choosetype"
              options={JSON.parse(sessionStorage.getItem("userGroup")) ?? []}
              getOptionLabel={(option) => option.name}
              value={state?.idmrole ?? []}
              fullWidth
              name="choosetype"
              // filterSelectedOptions
              multiple
              size="small"
              onChange={(e, value) => onHandleChange("idmrole", value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="idmrole"
                />
              )}
            />
          </Grid> */}
          <Grid item xs={12} sx={{ mt: 1 }}>
            <Typography variant="body2" gutterBottom>
              {"Choose Type"}
            </Typography>
            <Autocomplete
              id="choosetype"
              options={callTypes ?? []}
              getOptionLabel={(option) => option}
              value={state?.choosetype}
              fullWidth
              name="choosetype"
              // style={{ color: "#000" }}
              // PopperComponent={<Popper {...props} style={styles.popper} />}
              onChange={(e, value) => onHandleChange("choosetype", value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  size="small"
                  // margin="dense"
                  name="choosetype"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 1 }}>
            <Typography variant="body2" gutterBottom>
              {"Choose Form"}
            </Typography>
            <TextField
              id="outlined-name"
              // label="Enter State Name"
              name="chooseform"
              autoComplete="off"
              value={state?.chooseform}
              onChange={(e) => onHandleChange("chooseform", e.target.value)}
              placeholder="Search"
              fullWidth
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              margin="dense"
              // error={state?.errorStatesName}
              // helperText={state?.errorStatesName === true ? Message.requiredMessage : ""}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 1 }}>
            <Typography variant="body2" gutterBottom>
              {"API End Point"}
            </Typography>
            <TextField
              id="outlined-name"
              // label="Enter State Name"
              name="apiendpoint"
              value={state?.apiendpoint}
              onChange={(e) => onHandleChange("apiendpoint", e.target.value)}
              placeholder="Enter apiendpoint"
              fullWidth
              autoComplete="off"
              size="small"
              margin="dense"
              // error={state?.errorStatesName}
              // helperText={state?.errorStatesName === true ? Message.requiredMessage : ""}
            />
          </Grid>
          <Grid item lg={12} md={12} xs={12}>
            <Typography variant="body2" gutterBottom>
              {"Background Color"}
            </Typography>

            <ColorTextBox
              value={state?.bgcolor}
              onHandleChange={(data) => onHandleChange("bgcolor", data)}
            />
          </Grid>

          <Grid item lg={12} md={12} xs={12}>
            <Typography variant="body2" gutterBottom>
              {"Text Color"}
            </Typography>
            <ColorTextBox
              value={state?.textcolor}
              onHandleChange={(data) => onHandleChange("textcolor", data)}
            />
          </Grid>
          <Grid item lg={12} md={12} xs={12}>
            <Typography variant="body2" gutterBottom>
              State Icon
            </Typography>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FileUpload changeState={onHandleChange} label={"icon"} />
              {state?.icon && (
                <img
                  width="20"
                  height="20"
                  style={{ marginLeft: "8px", marginTop: "2px" }}
                  src={state?.icon}
                  alt={"Scenario Icon"}
                />
              )}
            </div>
          </Grid>

          <div className={classes.wrapperdiv3}>
            <Button
              id={"Cancel Button"}
              onClick={() => onPopoverClose()}
              variant="outlined"
            >
              {"Cancel"}
            </Button>
            {state?.isEdit ? (
              <Button
                id={"Update Button"}
                onClick={() => onUpdatepopover()}
                variant="contained"
                className={classes.Button}
                sx={{ ml: "16px" }}
              >
                {"Update"}
              </Button>
            ) : (
              <Button
                id={"Save Button"}
                onClick={() => onPopSave()}
                variant="contained"
                className={classes.Button}
                sx={{ ml: "16px" }}
              >
                {"Save"}
              </Button>
            )}
          </div>
        </Grid>
      </Popover>
    </div>
  );
};
